import React, { createContext, useReducer, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthContext = createContext();

const initialState = {
    isAuthenticated: false,
    user: null,
    token: null,
};

const authReducer = (state, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                isAuthenticated: true,
                user: action.payload.user,
                token: action.payload.token,
            };
        case 'LOGOUT':
            return {
                ...state,
                isAuthenticated: false,
                user: null,
                token: null,
            };
        default:
            return state;
    }
};

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(authReducer, initialState);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // F1 FIX: Use sessionStorage instead of localStorage for auth tokens.
        // sessionStorage is scoped to the tab/window and is cleared when the
        // session ends, reducing the XSS-token-theft window.
        const token = sessionStorage.getItem('token');

        if (token) {
            try {
                const user = JSON.parse(sessionStorage.getItem('user'));
                dispatch({
                    type: 'LOGIN',
                    payload: { user, token },
                });
            } catch {
                sessionStorage.clear();
            }
        }
    }, []);

    useEffect(() => {
        if (state.isAuthenticated) {
            sessionStorage.setItem('lastPath', location.pathname);
        }
    }, [location, state.isAuthenticated]);

    const login = (user, token) => {
        // F1 FIX: store in sessionStorage, not localStorage
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user', JSON.stringify(user));
        dispatch({
            type: 'LOGIN',
            payload: { user, token },
        });
        // "/" opens the first page the user is allowed to see
        const lastPath = sessionStorage.getItem('lastPath') || '/';
        navigate(lastPath);
    };

    const logout = () => {
        // F1 FIX: clear sessionStorage on logout
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('lastPath');
        dispatch({ type: 'LOGOUT' });
        navigate('/login');
    };

    return (
        <AuthContext.Provider value={{ ...state, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
